import PhaseThree from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseThree"
import React from "react"

const PhaseThreePage = () => {
    return (
        <React.Fragment>
            <PhaseThree />
        </React.Fragment>
    )
}
export default PhaseThreePage
